<template>
	<div class="container-wrap rtr_pay-c2c">
		<div class="container-box">
			<div class="card mb_10">
				<h3 class="title">
					<img
						:src="iconP2pTitle"
						alt=""
						style="width: 24px; height: 24px"
					/>P2P
				</h3>
			</div>
			<div class="card type1 mb_0 pr_0 pl_0 pt_20 pb_20">
				<div class="card_inner">
					<div
						:class="[
							'd_flex',
							'justify_between',
							'mr_20',
							'ml_20',
							isMobile ? 'mb_20' : 'mb_40',
						]"
						:style="isMobile ? { gap: '10px' } : {}"
					>
						<div
							:class="[
								'd_flex',
								isMobile
									? 'flex_column align_items_start w100'
									: 'align_items_center',
							]"
						>
							<div :class="['select_box', isMobile ? 'w100' : '']">
								<CustomSelectBox
									ref="sourceSelect"
									:placeholder="$t('input.placeholder.all_assets')"
									:options="sourceAssets"
									:searchable="true"
									@selectItem="selectSourceAsset"
								></CustomSelectBox>
							</div>
							<div :class="['more_button', isMobile ? 'mt_10' : '']">
								<a class="d_flex align_items_center" @click="modalSearch = true"
									>{{ $t('button.more') }} <span class="icon ADD"></span
								></a>
							</div>
						</div>
						<div
							:class="[
								'd_flex',
								isMobile ? 'w100 align_items_start' : 'align_items_center',
							]"
						>
							<button
								id="regist"
								:class="[
									{ selected: selectTab === 2 },
									'sell',
									'button_bg_blue',
									isMobile ? 'w100 mr_0' : 'mr_20',
								]"
								@click="selectTab(2)"
							>
								<img
									src="@/assets/images/v2/icon/icon-add-sell.svg"
									alt=""
									:style="isMobile ? { width: '14px', height: '14px' } : {}"
								/>
								{{ $t('c2c.sell.title') }}
							</button>
							<div class="refresh_button">
								<a @click="reset"
									><span id="refresh" class="icon REFRESH"></span
								></a>
							</div>
						</div>
					</div>

					<div class="list_wrap" v-if="!isMobile">
						<div class="title_area">
							<div class="box_1 pl_20">No.</div>
							<div class="box_2">{{ $t('c2c.th1') }}</div>
							<div class="box_3">{{ $t('c2c.th2') }}</div>
							<div class="box_4">{{ $t('c2c.th3') }}</div>
							<div class="box_5">{{ $t('c2c.th4') }}</div>
							<div class="box_6">
								<a
									>{{ $t('c2c.th5') }}<span class="icon FILTER"></span>
									<div class="pop_wrap">
										<div class="pop">
											<div class="d_flex flex_column">
												<div class="radio_wrap">
													<input
														v-model="status"
														type="radio"
														name="status"
														id="all"
														value=""
														checked
													/>
													<label for="all">{{ $t('c2c.status1') }}</label>
												</div>
												<div class="radio_wrap">
													<input
														v-model="status"
														type="radio"
														name="status"
														id="open"
														value="OPEN"
													/>
													<label for="open">{{ $t('c2c.OPEN') }}</label>
												</div>
												<div class="radio_wrap">
													<input
														v-model="status"
														type="radio"
														name="status"
														id="complete"
														value="COMPLETED"
													/>
													<label for="complete">{{
														$t('c2c.COMPLETED')
													}}</label>
												</div>
												<div class="radio_wrap">
													<input
														v-model="status"
														type="radio"
														name="status"
														id="cancel"
														value="CANCELED"
													/>
													<label for="cancel">{{ $t('c2c.status4') }}</label>
												</div>
											</div>
										</div>
									</div>
								</a>
							</div>
						</div>

						<div class="list_area">
							<div class="list">
								<ul class="pl_0">
									<li
										v-for="item in dealList"
										:key="item.seq"
										class="list_item"
									>
										<div class="box_1">
											<span class="list_num">{{ item._no }}</span>
										</div>
										<div class="box_2">
											<div class="d_flex flex_column">
												<div class="asset_box">
													<span
														:class="[item.source_asset_code, 'small']"
													></span>
													<p class="code mr_4 mb_0">
														{{ item.source_asset_code }}
													</p>
													<p class="name mb_0">{{ item.source_asset_title }}</p>
												</div>
												<p class="text_type02 mb_0">
													{{
														$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') +
														' | '
													}}
													{{ item.user_id !== 'null' ? item.user_id : '' }}
												</p>
											</div>
										</div>
										<div class="box_3">
											<p class="amount">{{ item.potential_source_amount }}</p>
										</div>
										<div class="box_4">
											<p class="amount">
												1 <span>{{ item.source_asset_code }} =</span>
											</p>
											<p class="amount">
												{{ item.min_price }}
												<span>{{ item.target_asset_code }}</span>
											</p>
										</div>
										<div class="box_5">
											<div class="asset_box">
												<span :class="[item.target_asset_code, 'small']"></span>
												<p class="code mr_4 mb_0">
													{{ item.target_asset_code }}
												</p>
												<p class="name mb_0">{{ item.target_asset_title }}</p>
											</div>
										</div>
										<div class="box_6 pr_20">
											<div class="d_flex justify_between status_area">
												<div
													:class="[
														{
															open: item.status === 'OPEN',
															cancel: item.status === 'CANCELED',
															completed: item.status === 'COMPLETED',
														},
														'd_flex',
														'align_items_center',
														'status',
													]"
												>
													<span class="icon"></span>
													<span>{{ $t('c2c.' + item.status) }}</span>
												</div>
												<button
													id="purchaseRequest"
													class="button_bg_blue"
													@click="createBuyHandler(item)"
													:disabled="item.status !== 'OPEN'"
												>
													{{ $t('c2c.buy.title') }}
												</button>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="table_mobile" v-if="dealList.length > 0 && isMobile">
						<div
							v-for="item in dealList"
							:key="item.seq"
							class="table_item_mobile"
						>
							<div class="list_item_mobile">
								<div class="cont">
									<div class="list_title_box">
										<div class="num">{{ item._no }}</div>
										<div class="status_area">
											<div
												:class="[
													{
														open: item.status === 'OPEN',
														cancel: item.status === 'CANCELED',
														completed: item.status === 'COMPLETED',
													},
													'status',
												]"
											>
												<span class="icon"></span>
												<span>{{ $t('c2c.' + item.status) }}</span>
											</div>
										</div>
									</div>
									<div class="list_info_box">
										<div class="item_row">
											<p class="label">{{ $t('c2c.th1') }}</p>
											<div class="row_cont">
												<div class="asset_box">
													<span
														:class="[item.source_asset_code, 'small']"
													></span>
													<p class="code mr_4 mb_0">
														{{ item.source_asset_code }}
													</p>
													<p class="name mb_0">
														{{ item.source_asset_title }}
													</p>
												</div>
												<div class="date text_type02">
													{{
														$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss')
													}}
													{{
														item.user_id !== 'null' ? ' | ' + item.user_id : ''
													}}
												</div>
											</div>
										</div>
										<div class="item_row">
											<p class="label">{{ $t('c2c.th4') }}</p>
											<div class="row_cont">
												<div class="asset_box">
													<span
														:class="[item.target_asset_code, 'small']"
													></span>
													<p class="code mr_4 mb_0">
														{{ item.target_asset_code }}
													</p>
													<p class="name mb_0">
														{{ item.target_asset_title }}
													</p>
												</div>
											</div>
										</div>
										<div class="item_row">
											<p class="label">{{ $t('c2c.th2') }}</p>
											<div class="row_cont">
												<p class="amount">
													{{ item.potential_source_amount }}
												</p>
											</div>
										</div>
										<div class="item_row">
											<p class="label">{{ $t('c2c.th3') }}</p>
											<div class="row_cont">
												<div class="price_info">
													<p class="amount">
														1 <span>{{ item.source_asset_code }} =</span>
													</p>
													<p class="amount">
														{{ item.min_price }}
														<span>{{ item.target_asset_code }}</span>
													</p>
												</div>
											</div>
										</div>
										<div class="item_row">
											<div></div>
											<div class="button_area">
												<button
													id="purchaseRequest"
													class="button_bg_blue"
													@click="createBuyHandler(item)"
													:disabled="item.status !== 'OPEN'"
												>
													{{ $t('c2c.buy.title') }}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<pagination
						:totalCount="pageNavigation.total_count"
						:totalPage="pageNavigation.total_page"
						:curPage="pageNavigation.cur_page"
						:point="pageNavigation.point"
						:firstPage="pageNavigation.first_page"
						:lastPage="pageNavigation.last_page"
						@change="pageChangeHandler"
					></pagination>
				</div>
			</div>
		</div>
	</div>
	<ModalView v-if="modalSearch" @closeModal="modalSearch = false">
		<AssetSearch :markets="markets" @selectAsset="selectAsset"></AssetSearch>
	</ModalView>
	<ModalView class="buy_modal" v-if="modalBuy" @closeModal="modalBuy = false">
		<C2cBuy :deal-seq="selectedDealSeq" @close="closeBuyModal"></C2cBuy>
	</ModalView>
	<ModalView class="sell_modal" v-if="modalSell" @closeModal="closeSellModal">
		<C2cSell @closeModal="closeSellModal"></C2cSell>
	</ModalView>
	<ModalView
		v-if="modalAccountCheck"
		class="check_modal"
		@closeModal="modalAccountCheck = false"
	>
		<CheckAccount
			:source-asset-seq="selectedMarket.source_asset_seq"
			:target-asset-seq="selectedMarket.target_asset_seq"
			@createAccount="createAccount"
		></CheckAccount>
	</ModalView>
	<ModalView
		v-if="modalAccountRegist"
		class="register_modal"
		@closeModal="closeRegistModal"
	>
		<h3 class="title mb_20">
			{{ $t('rtr_wallet_account-assets.title3') }}
		</h3>
		<AccountRegister
			@closeRegist="closeRegistModal"
			:asset-info="createAsset"
		></AccountRegister>
	</ModalView>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomSelectBox from '@/components/CustomSelectBox';
import ModalView from '@/components/Layout/ModalView';
import AssetSearch from '@/components/User/Pay/AssetSearch';
import C2cBuy from '@/components/User/Pay/C2cBuy';
import C2cSell from '@/components/User/Pay/C2cSell';
import CheckAccount from '@/components/User/Pay/CheckAccount';
import AccountRegister from '@/components/AccountRegister';
import { commonError } from '@/common/dialog';
import pagination from '@/components/Pagination';
import { fetchPrivateMarketDeal, fetchPrivateMarkets } from '@/api/market';
import { uniqBy } from 'lodash';
import Tutorial from '@/components/Tutorial';
import iconP2pTitle from '@/assets/images/v2/icon/icon-p2p-title.svg';
import Cookies from 'js-cookie';

export default {
	name: 'C2c',
	components: {
		CustomSelectBox,
		pagination,
		ModalView,
		AssetSearch,
		C2cBuy,
		C2cSell,
		CheckAccount,
		AccountRegister,
		Tutorial,
	},
	data() {
		return {
			sourceAssetSeq: null,
			status: '',
			markets: [],
			dealList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			modalSearch: false,
			modalAccountCheck: false,
			modalAccountRegist: false,
			modalBuy: false,
			modalSell: false,
			selectedTab: 1,
			selectedMarketSeq: null,
			selectedDealSeq: null,
			createAsset: {},
			tour: null,
			showTutorial: false,
			iconP2pTitle,
			isMobile: false,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('assets', ['assets', 'registedAssets']),

		sourceAssets() {
			const result = [];
			this.markets.forEach(market => {
				const asset = this.registedAssets.find(asset => {
					return asset.seq === market.source_asset_seq;
				});
				if (asset) result.push(asset);
			});
			return uniqBy(result, 'seq');
		},
		selectedMarket() {
			return this.markets.find(item => {
				return item.seq === this.selectedMarketSeq;
			});
		},
	},
	watch: {
		sourceAssetSeq() {
			this.curPage = 1;
			this.loadPrivateDealList();
		},
		status() {
			this.curPage = 1;
			this.loadPrivateDealList();
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			Promise.all([this.loadPrivateMarkets(), this.loadPrivateDealList()]);
		},
		async loadPrivateMarkets() {
			const { data } = await fetchPrivateMarkets().catch(commonError);
			this.markets = data.filter(item => {
				return item.is_active === 'Y';
			});
		},
		async loadPrivateDealList() {
			const params = {
				status: this.status,
				source_asset_seq: this.sourceAssetSeq,
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchPrivateMarketDeal(
				params,
			).catch(commonError);
			this.dealList = data;
			this.pageNavigation = page_navigation;
		},
		reset() {
			this.$refs.sourceSelect.initSelected();
			this.sourceAssetSeq = null;
			this.status = '';
			this.curPage = 1;
		},
		selectSourceAsset(assetSeq) {
			this.sourceAssetSeq = assetSeq;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadPrivateDealList();
		},
		selectAsset(assetSeq) {
			this.$refs.sourceSelect.selectItem(assetSeq);
			this.modalSearch = false;
		},
		createBuyHandler(deal) {
			if (deal) {
				this.selectedMarketSeq = deal.market_seq;
				this.selectedDealSeq = deal.seq;
			}
			if (!this.checkAccounts()) {
				this.modalAccountCheck = true;
			} else {
				this.modalBuy = true;
			}
		},
		checkAccounts() {
			const sourceAccount = this.accounts.find(account => {
				return account.asset_seq === this.selectedMarket.source_asset_seq;
			});
			const sourceAsset = this.registedAssets.find(asset => {
				return asset.seq === this.selectedMarket.source_asset_seq;
			});
			const targetAccount = this.accounts.find(account => {
				return account.asset_seq === this.selectedMarket.target_asset_seq;
			});
			const targetAsset = this.registedAssets.find(asset => {
				return asset.seq === this.selectedMarket.target_asset_seq;
			});
			return !(
				(!sourceAccount && sourceAsset.is_active === 'Y') ||
				(!targetAccount && targetAsset.is_active === 'Y')
			);
		},
		createAccount(seq) {
			this.createAsset = this.assets.find(item => {
				return item.seq === seq;
			});
			this.modalAccountCheck = false;
			this.modalAccountRegist = true;
		},
		selectTab(e) {
			this.selectedTab = e;
			if (this.selectedTab === 2) {
				this.modalSell = true;
			}
		},
		closeRegistModal() {
			this.modalAccountRegist = false;
			this.createBuyHandler();
		},
		closeBuyModal() {
			this.modalBuy = false;
			this.reset();
			this.loadPrivateDealList();
		},
		closeSellModal() {
			this.selectedTab = 1;
			this.modalSell = false;
			this.reset();
			this.loadPrivateDealList();
		},
		tutorialHandler() {
			if (!Cookies.get(this.$route.name + '_tutorial')) {
				this.showTutorial = true;
			}
		},
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
	},
	mounted() {
		this.tutorialHandler();
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
};
</script>
